<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="service-details-sidebar" position="left" lockedOpen="gt-md">
        <service-details-sidebar></service-details-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CONTENT -->
    <div class="center mat-card" *ngIf="service != null">
        <div class="h2 mt-16">{{ service.name }}</div>

        <table class="simple invoice-table">
            <tbody>
            <tr>
                <td class="text-left"><div class="title">{{'Category'|translate}}</div></td>
                <td class="text-left">{{service.category.name}}</td>
            </tr>
            <tr>
                <td class="text-left"><div class="title">{{'Duration'|translate}}</div></td>
                <td class="text-left">{{service.requiredTime}} {{'minuts'|translate}}</td>
            </tr>
            <tr>
                <td class="text-left"><div class="title">{{'Price'|translate}}</div></td>
                <td class="text-left">{{service.priceGross}} zł</td>
            </tr>
            <tr>
                <td class="text-left"><div class="title">{{'Popularity'|translate}}</div></td>
                <td class="text-left">{{service.popularity}} {{'times'|translate}}</td>
            </tr>
            <tr>
                <td class="text-left"><div class="title">{{'TAX'|translate}}</div></td>
                <td class="text-left">{{service.vatRate.vatName}}</td>
            </tr>
            <tr>
                <td class="text-left"><div class="title">{{'Reservations online'|translate}}</div></td>
                <td class="text-left">
                    <span *ngIf="service.onlineReservation">{{'Service can be reserved online'|translate}}</span>
                    <span *ngIf="!service.onlineReservation">{{'Service can not be reserved online'|translate}}</span>
                </td>
            </tr>
            <tr>
                <td class="text-left"><div class="title">{{'Public description'|translate}}</div></td>
                <td class="text-left">
                    <span *ngIf="!service.description">{{'No description'|translate}}</span>
                    {{service.description}}
                </td>
            </tr>
            <tr>
                <td class="text-left"><div class="title">{{'Private description'|translate}}</div></td>
                <td class="text-left">
                    <span *ngIf="!service.privateDescription">{{'No description'|translate}}</span>
                    {{service.privateDescription}}
                </td>
            </tr>
            <tr>
                <td class="text-left"><div class="title">{{'Images'|translate}}</div></td>
                <td class="text-left">
                    <span *ngIf="service.images.length==0">{{'No images'|translate}}</span>
                </td>
            </tr>
            </tbody>
        </table>

        <br/><br/>

        <div class="h3 mt-16">{{ 'Assigned resources'|translate }}</div>
        <table class="simple invoice-table">
            <tbody>
                <tr *ngFor="let resourceGroup of service.resourceGroups; let first = first;">
                    <td>
                        <div class="title" *ngIf="first">{{'Require'|translate}}</div>
                        <div class="title" *ngIf="!first">{{'Require additionally'|translate}}</div>
                    </td>
                    <td>
                        <span *ngFor="let resource of resourceGroup.resources; let last = last;">
                            <a routerLink="/settings/resources/edit/{{resource.id}}">{{resource.name}}</a> <span *ngIf="!last">&nbsp;{{'or'|translate}}&nbsp;</span>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
